module.exports = __webpack_public_path__ + "img/mapa-parking-cruceros-barcelona.3ea7ff73.jpg";